import { numberMoney } from 'Data/format.js'

export function getRemainingMaxDiscount(max_discount, treatment_discounts) {
  if (max_discount == null) return '-'
  let remaining = max_discount - treatment_discounts
  return numberMoney(remaining < 0 ? 0 : remaining)
}
